import { ModalConfig } from './../models/modal.config';

export class ModalConfigHelper {
  public static getAtachmentModalConfig = (onDismiss: any, onClose: any): ModalConfig => {
    return  {
      modalTitle: 'Attachment',
      closeButtonLabel: 'Save',
      dismissButtonLabel: 'Cancel',
      onDismiss: onDismiss,
      onClose: onClose,
      ignoreBackdropClick: 'static',
      scrollable: false,
      size: 'sm'
    }
  }

  public static getPaymentModalConfig = (onDismiss: any, onClose: any): ModalConfig => {
    return  {
      modalTitle: 'Payment',
      closeButtonLabel: 'Close',
      onClose: onClose,
      ignoreBackdropClick: 'static',
      hideDismissButton: () => true,
      scrollable: false
    }
  }

  public static getEmailVerificationModalConfig = (onDismiss: any, onClose: any): ModalConfig => {
    return  {
      modalTitle: 'Account Activation',
      closeButtonLabel: 'Close',
      onClose: onClose,
      ignoreBackdropClick: 'static',
      hideDismissButton: () => true,
      scrollable: false
    }
}

  public static getConfimationModalDialog = (onDismiss: any, onClose: any): ModalConfig => {
    return  {
      modalTitle: 'Warning',
      closeButtonLabel: 'Yes',
      dismissButtonLabel: 'No',
      onClose: onClose,
      onDismiss: onDismiss,
      ignoreBackdropClick: 'static',
      hideDismissButton: () => false,
      scrollable: false
    }
  }

  public static getReportModalConfig = (onDismiss: any, onClose: any): ModalConfig => {
    return  {
      modalTitle: 'Reason to Report',
      closeButtonLabel: 'Save',
      dismissButtonLabel: 'Cancel',
      onDismiss: onDismiss,
      onClose: onClose,
      ignoreBackdropClick: 'static',
      scrollable: false
    }
  }

  public static getPrivacyModalConfig = (onDismiss: any): ModalConfig => {
    return  {
      modalTitle: 'Privacy Statement',
      hideCloseButton: () => true,
      dismissButtonLabel: 'Close',
      onDismiss: onDismiss,
      ignoreBackdropClick: 'static',
      scrollable: true
    }
  }

  public static getContactUsModalConfig = (onDismiss: any): ModalConfig => {
    return  {
      modalTitle: 'Contact Us',
      hideCloseButton: () => true,
      dismissButtonLabel: 'Close',
      onDismiss: onDismiss,
      ignoreBackdropClick: 'static',
      scrollable: false
    }
  }

  public static getDiscussModalConfig = (onDismiss: any): ModalConfig => {
    return  {
      modalTitle: 'Discuss Job',
      hideCloseButton: () => true,
      dismissButtonLabel: 'Close',
      onDismiss: onDismiss,
      ignoreBackdropClick: 'static',
      scrollable: true
    }
  }

  public static getTeamConfig = (onDismiss: any): ModalConfig => {
    return  {
      modalTitle: 'Team',
      hideCloseButton: () => true,
      dismissButtonLabel: 'Close',
      onDismiss: onDismiss,
      ignoreBackdropClick: 'static',
      scrollable: false
    }
  }

  public static getAboutModalConfig = (onDismiss: any): ModalConfig => {
    return  {
      modalTitle: 'About Manzoul',
      hideCloseButton: () => true,
      dismissButtonLabel: 'Close',
      onDismiss: onDismiss,
      ignoreBackdropClick: 'static',
      scrollable: true
    }
  }

}
